module.exports = __webpack_public_path__ + "img/jsm.58667f82.jpg";